import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';

const AccordionElementBase = (superClass) => {
    class AccordionElement extends superClass {
        constructor() {
            super(...arguments);
            this.title = '';
            this.subtitle = '';
            this.image = '';
            this.imageAlt = '';
            this.index = '';
            this.elementDetails = '';
            this.isGroupsite = false;
            this.titleColor = '';
            this.dividerColor = '';
            this.arrowIcon = '';
        }
        collapseInactiveItem() {
            const header = this.shadowRoot && this.shadowRoot.querySelector('.header');
            if (header &&
                header.getAttribute('active') === null &&
                header.nextElementSibling)
                header.nextElementSibling.style.maxHeight = '';
        }
        expandActiveItem() {
            const activeHeader = this.shadowRoot && this.shadowRoot.querySelector('.header[active]');
            if (activeHeader && activeHeader.nextElementSibling) {
                activeHeader.nextElementSibling.style.maxHeight = `${activeHeader.nextElementSibling.scrollHeight}px`;
            }
        }
        handleClick(e) {
            const ariaAttr = 'aria-expanded';
            const accHeader = e.target.closest('.header');
            const accContent = accHeader.nextElementSibling;
            const inner = accContent.querySelector('.inner');
            this.parentNode.querySelectorAll('accordion-item').forEach((el) => {
                const content = el.shadowRoot.querySelector('.content');
                const accItem = el.shadowRoot.querySelector('.header');
                if (accItem !== accHeader) {
                    accItem.removeAttribute('active');
                    accItem.setAttribute(ariaAttr, 'false');
                    content.style.maxHeight = '';
                }
            });
            if (accHeader.hasAttribute('active')) {
                accHeader.removeAttribute('active');
                accHeader.setAttribute(ariaAttr, 'false');
                accContent.style.maxHeight = null;
            }
            else {
                accHeader.setAttribute('active', '');
                accHeader.setAttribute(ariaAttr, 'true');
                const acctordionContent = accContent.querySelector('slot[name="accordion-content"]') ||
                    accContent.querySelector('slot[name="image-accordion-content"]');
                if (acctordionContent === null || acctordionContent === void 0 ? void 0 : acctordionContent.assignedElements()) {
                    accContent.style.maxHeight = `${inner.offsetHeight}px`;
                }
            }
            if (this.onToggle)
                this.onToggle(accContent);
        }
        firstUpdated() {
            this.expandActiveItem();
        }
        updated() {
            if (this.isExpanded)
                this.expandActiveItem();
            this.collapseInactiveItem();
        }
        // eslint-disable-next-line class-methods-use-this
        renderAccordionElement(content) {
            return x `${content}`;
        }
    }
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "title", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "subtitle", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "image", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "imageAlt", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "index", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "elementDetails", void 0);
    __decorate([
        n({ type: Boolean })
    ], AccordionElement.prototype, "isDisabled", void 0);
    __decorate([
        n({ type: Boolean })
    ], AccordionElement.prototype, "isExpanded", void 0);
    __decorate([
        n({ type: Boolean })
    ], AccordionElement.prototype, "highlightActiveItem", void 0);
    __decorate([
        n({ type: Boolean })
    ], AccordionElement.prototype, "smallTitles", void 0);
    __decorate([
        n({ type: Boolean })
    ], AccordionElement.prototype, "rtl", void 0);
    __decorate([
        n({ type: Boolean })
    ], AccordionElement.prototype, "isGroupsite", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "titleColor", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "dividerColor", void 0);
    __decorate([
        n({ type: String })
    ], AccordionElement.prototype, "arrowIcon", void 0);
    __decorate([
        n({ type: Function })
    ], AccordionElement.prototype, "onToggle", void 0);
    return AccordionElement;
};

export { AccordionElementBase };
